import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e2e8f0;
`;

const Title = styled.h3`
    margin: 0;
    font-size: 0.9rem;
    font-weight: 700;
    color: #0f172a;
    font-family: "Inter", system-ui, sans-serif;
`;

const Body = styled.div`
    padding: 20px;
`;

export const SettingsSection = ({ title, cardActions, children }) => (
    <Wrap>
        <Header>
            <Title>{title}</Title>
            {cardActions && <div>{cardActions}</div>}
        </Header>
        <Body>{children}</Body>
    </Wrap>
);
